import { isLoggedIn } from "utils/auth";

export default (store) => {
  return {
    path: "offers/create",
    onEnter: isLoggedIn(store),
    getComponent(nextState, cb) {
      require.ensure(
        [],
        (require) => {
          const Offer = require("./containers/Offer").default;
          cb(null, Offer);
        },
        "offer"
      );
    },
  };
};



// WEBPACK FOOTER //
// ./src/routes/Offer/index.js